'use client';

import React from 'react';
import AppLink from '@/componentv2/AppLink/AppLink';
import Badge from '@/componentv2/badge/badge';
import './mobileHamburgerMenu.scss';
import { productsNavLinks } from '@/componentv2/nav/productNavLinks';
import { getNavLinkAriaLabel } from '@/componentv2/nav/getNavLinkAriaLabel';

interface MobileHamburgerMenuProps {
  isOpen: boolean;
  onClose: () => void;
}

const MobileHamburgerMenu: React.FC<MobileHamburgerMenuProps> = ({
  isOpen,
  onClose,
}) => {
  return (
    <>
      {isOpen && <div className="mobile-menu-overlay" onClick={onClose} />}

      <div className={`mobile-menu ${isOpen ? 'open' : ''}`}>
        {isOpen && (
          <div className="mobile-menu-content">
            <div className="mobile-menu-section">
              <h3 className="mobile-menu-heading">Products</h3>
              {productsNavLinks.map((item) => (
                <AppLink
                  key={item.id}
                  href={item.href}
                  intent="navigation"
                  className="mobile-menu-item"
                  aria-label={getNavLinkAriaLabel(item.label, item.badge)}
                  onClick={onClose}
                >
                  <span>{item.label}</span>
                  {item.badge && <Badge label={item.badge} ariaHidden />}
                </AppLink>
              ))}
            </div>

            <AppLink
              href="/pricing"
              intent="primary"
              className="mobile-menu-link"
              onClick={onClose}
            >
              Pricing
            </AppLink>
            <AppLink
              href="/templates"
              intent="navigation"
              className="mobile-menu-link"
              onClick={onClose}
            >
              Templates
            </AppLink>
            <AppLink
              href="/resources"
              intent="navigation"
              className="mobile-menu-link"
              onClick={onClose}
            >
              Resources & Tips
            </AppLink>
            <AppLink
              href="/blog"
              intent="navigation"
              className="mobile-menu-link"
              onClick={onClose}
            >
              Blog
            </AppLink>
            <AppLink
              href="/case-studies"
              intent="navigation"
              className="mobile-menu-link"
              onClick={onClose}
            >
              Case Studies
            </AppLink>
            <AppLink
              href="/videos"
              intent="navigation"
              className="mobile-menu-link"
              onClick={onClose}
            >
              Videos
            </AppLink>
            <AppLink
              href="/enterprise"
              intent="navigation"
              className="mobile-menu-link"
              onClick={onClose}
            >
              Enterprise
            </AppLink>
            <AppLink
              href="/findasignup"
              intent="navigation"
              className="mobile-menu-link"
              onClick={onClose}
            >
              Search
            </AppLink>
            <a
              href="https://support.signupgenius.com/hc/en-us"
              className="mobile-menu-link"
              onClick={onClose}
            >
              Help
            </a>
          </div>
        )}
      </div>
    </>
  );
};

export default MobileHamburgerMenu;
